export const userRoles = [
  { name: 'All roles', value: 'all' },
  { name: 'Admin', value: 'admin' },
  { name: 'Senior Master', value: 'senior master' },
  { name: 'Master', value: 'master' },
  { name: 'Agent', value: 'agent' },
  { name: 'User', value: 'user' },
]

export const userStatuses = [
  { name: 'Any status', value: 'all' },
  { name: 'Active', value: 'active' },
  { name: 'Suspended', value: 'suspended' },
  { name: 'Locked', value: 'locked' },
]

export const balanceTransactionTypes = [
  { name: 'Add Balance', value: 'add' },
  { name: 'Remove Balance', value: 'remove' },
  // { name: 'Rebate Adjustment', value: 'rebate' },
  // { name: 'Compensation', value: 'compensation' },
]

export const demoUserList = [
  {
    id: 'USR-10422',
    username: 'Alicia Hart',
    role: 'Admin',
    balance: 1520.33,
    status: 'Active',
  },
  {
    id: 'USR-10981',
    username: 'Jonas Burke',
    role: 'Finance',
    balance: 987.5,
    status: 'Suspended',
  },
  {
    id: 'USR-10577',
    username: 'Mara Dorsey',
    role: 'Supervisor',
    balance: 412.15,
    status: 'Active',
  },
  {
    id: 'USR-10866',
    username: 'Kevin Patel',
    role: 'Support',
    balance: 87.0,
    status: 'Active',
  },
  {
    id: 'USR-10475',
    username: 'Nelia Ko',
    role: 'Finance',
    balance: 2307.88,
    status: 'Locked',
  },
  {
    id: 'USR-10234',
    username: 'Samuel Ortiz',
    role: 'Supervisor',
    balance: 640.2,
    status: 'Active',
  },
]

export const demoTransactionLogs = {
  1: [
    {
      id: 'TRX-90001',
      type: 'Credit',
      amount: 400,
      channel: 'Manual',
      balanceAfter: 1520.33,
      createdAt: '2025-10-28T10:15:00Z',
      note: 'Promo adjustment by finance',
    },
    {
      id: 'TRX-89992',
      type: 'Debit',
      amount: 180,
      channel: 'Auto',
      balanceAfter: 1120.33,
      createdAt: '2025-10-25T18:05:00Z',
      note: 'Parlay settlement',
    },
  ],
  2: [
    {
      id: 'TRX-90016',
      type: 'Debit',
      amount: 320,
      channel: 'Manual',
      balanceAfter: 987.5,
      createdAt: '2025-10-30T09:40:00Z',
      note: 'Chargeback investigation',
    },
  ],
  3: [
    {
      id: 'TRX-90021',
      type: 'Credit',
      amount: 75,
      channel: 'Auto',
      balanceAfter: 412.15,
      createdAt: '2025-10-27T21:32:00Z',
      note: 'Referral rebate',
    },
  ],
  4: [
    {
      id: 'TRX-90018',
      type: 'Debit',
      amount: 50,
      channel: 'Manual',
      balanceAfter: 87.0,
      createdAt: '2025-10-29T14:20:00Z',
      note: 'Compliance penalty',
    },
  ],
  5: [
    {
      id: 'TRX-90010',
      type: 'Credit',
      amount: 210,
      channel: 'Manual',
      balanceAfter: 2307.88,
      createdAt: '2025-10-28T11:18:00Z',
      note: 'High roller adjustment',
    },
  ],
  6: [
    {
      id: 'TRX-90028',
      type: 'Credit',
      amount: 90,
      channel: 'Auto',
      balanceAfter: 640.2,
      createdAt: '2025-10-26T17:12:00Z',
      note: 'Mission bonus',
    },
  ],
}


